export default __webpack_public_path__ + "static/media/locations.717189c8.svg";